"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseCurrencyValue;

var _I18n = _interopRequireDefault(require("I18n"));

function getCurrencyPrecision(currencyCode) {
  var currencyData = _I18n.default.currencySymbols[currencyCode];
  return currencyData ? currencyData.decimal_digits : 2;
} // this is needed to parse out trailing 0s that we're not expecting which can change the number completely or cause a NaN to show up
// for more info see https://git.hubteam.com/HubSpot/customer-data-objects-ui-components/pull/112


function parseCurrencyValue(_ref) {
  var value = _ref.value,
      currencyCode = _ref.currencyCode;

  if (!value) {
    return value;
  }

  var amountParsedI18n = _I18n.default.parseNumber(value);

  if (_I18n.default.formatNumber(amountParsedI18n) === value || _I18n.default.formatNumber(amountParsedI18n, {
    strip_insignificant_zeros: false,
    precision: getCurrencyPrecision(currencyCode)
  }) === value) {
    return amountParsedI18n;
  }

  return parseFloat(value);
}

module.exports = exports.default;